/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idnes_SetupInputs */

const cs_idnes_setup = /** @type {(inputs: Idnes_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit iDNES Reality`)
};

const en_idnes_setup = /** @type {(inputs: Idnes_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up iDNES Reality`)
};

/**
* | output |
* | --- |
* | "Set up iDNES Reality" |
*
* @param {Idnes_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const idnes_setup = /** @type {((inputs?: Idnes_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idnes_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_idnes_setup(inputs)
	return cs_idnes_setup(inputs)
});